import React from 'react';
import { useHistory } from "react-router-dom";
import { Image, Svg, CurrencyBadge } from '../../index'
import Moment from 'react-moment';
import 'moment/locale/zh-tw';
import styles from './accountingBookLabel.module.scss'

const AccountingBookLabel = (props) => {
  const history = useHistory();
  let object = props.object

  const calendar = {
    sameDay: '[今日]',
    lastDay: '[昨日]',
    sameElse: 'YYYY.MM.DD',
    nextWeek: 'YYYY.MM.DD',
    lastWeek: 'YYYY.MM.DD',
  }

  const handleClicked = () => {
    history.push(`accounting_books/${object.uuid}/overview`)
  }

  const handleSetAsCurrent = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (!props.disabled) {
      props.handleSetCurrent(object.uuid)
    }
    return false
  }

  // 帳本名稱最多顯示 8 個全形字，超過則截斷加上省略號避免小螢幕溢出
  const MAX_NAME_LENGTH = 8
  const name = object.name || ''
  const displayName = name.length > MAX_NAME_LENGTH
    ? `${name.slice(0, MAX_NAME_LENGTH)}…`
    : name

  return (
    <div className={styles.card} onClick={handleClicked}>
      <Image imageUrl={object.imageUrl} size='52px' circle />
      <div className={styles.info}>
        <div className={styles.name}>
          <span className={styles.nameText} title={name}>{displayName}</span>
          <CurrencyBadge currency={object.currency} style={{ marginLeft: '8px', flexShrink: 0 }} />
        </div>
        <div className={styles.date}>
          建立日期：<Moment calendar={calendar} local locale="zh-tw">{object.created_at}</Moment>
        </div>
      </div>
      <div className={styles.right}>
        {props.current && <span className={styles.defaultTag}>預設</span>}
        <span className={[styles.iconBox, styles.star].join(' ')} onClick={handleSetAsCurrent}>
          <Svg icon={props.current ? 'favorateYes' : 'favorateNo'} size='20' />
        </span>
        <span className={[styles.iconBox, styles.chevron].join(' ')}>
          <Svg icon='rightArrow' color='black' size='18' />
        </span>
      </div>
    </div>
  )
};

export default AccountingBookLabel;
